// theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    dark: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      950: '#030712',
    },
    crypto: {
      green: {
        300: '#6ee7b7',
        400: '#34d399',
        500: '#10b981',
        600: '#059669',
        700: '#047857',
      },
      purple: {
        300: '#c084fc',
        400: '#a855f7',
        500: '#9333ea',
        600: '#7c3aed',
        700: '#6d28d9',
      },
      blue: {
        300: '#93c5fd',
        400: '#60a5fa',
        500: '#3b82f6',
        600: '#2563eb',
        700: '#1d4ed8',
      }
    },
  },
  fonts: {
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    heading: "'SF Pro Display', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    mono: "'SF Mono', 'JetBrains Mono', SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
  },
  styles: {
    global: (props) => ({
      body: {
        bg: 'linear-gradient(180deg, rgb(0, 0, 0) 0%, rgb(7, 35, 7) 100%)',
        color: 'white',
        position: 'relative',
        overflowX: 'hidden',
        letterSpacing: '-0.01em',
        width: '100%',
        minHeight: '100vh',
      },
      '::-webkit-scrollbar': {
        width: '6px',
      },
      '::-webkit-scrollbar-track': {
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '6px',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(16, 185, 129, 0.5)',
        borderRadius: '6px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(16, 185, 129, 0.7)',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '500',
        _hover: {
          transform: 'translateY(-2px)',
          boxShadow: 'md',
        },
        _active: {
          transform: 'translateY(0)',
        },
      },
      variants: {
        primary: {
          bgGradient: 'linear(to-r, crypto.green.400, crypto.green.500)',
          color: 'white',
          _hover: {
            bgGradient: 'linear(to-r, crypto.green.500, crypto.green.600)',
            transform: 'translateY(-2px)',
            boxShadow: 'md',
          },
        },
        secondary: {
          bg: 'whiteAlpha.200',
          color: 'white',
          _hover: {
            bg: 'whiteAlpha.300',
            transform: 'translateY(-2px)',
            boxShadow: 'md',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'rgba(15, 27, 14, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '1px solid',
          borderColor: 'rgba(78, 224, 53, 0.2)',
          borderRadius: '12px',
          transition: 'all 0.3s ease',
          _hover: {
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    Input: {
      baseStyle: {
        field: {
          color: 'white',
          backgroundColor: 'rgba(0, 0, 0, 0.8) !important',
          _placeholder: {
            color: 'rgba(156, 163, 175, 0.7) !important',
          },
          _focus: {
            borderColor: 'rgba(16, 185, 129, 0.5) !important',
            boxShadow: '0 0 0 2px rgba(16, 185, 129, 0.2) !important',
          },
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          color: 'white',
          backgroundColor: 'rgba(0, 0, 0, 0.8) !important',
          _focus: {
            borderColor: 'rgba(16, 185, 129, 0.5) !important',
            boxShadow: '0 0 0 2px rgba(16, 185, 129, 0.2) !important',
          },
        },
      },
    },
  },
});

export default theme;